import { Component, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDialog,
  MatPaginator,
  MatSort,
  MatTableDataSource,
} from "@angular/material";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "src/app/app.config";
import { ConfirmDialogComponent, ConfirmDialogModel } from "src/app/shared/components/confirm-dialog/confirm-dialog.component";
import { MonthClosureService } from "src/app/shared/service/month-closure.service";
import { UserService } from "src/app/shared/service/user.service";
import { isNullOrUndefined } from "util";

@Component({
  selector: "app-hr-designationchanges-details",
  templateUrl: "./hr-designationchanges-details.component.html",
  styleUrls: ["./hr-designationchanges-details.component.css"],
})
export class HRDesignationChangesDetailsComponent implements OnInit {
  isFreeze = false;
  designationchangesDataSource: MatTableDataSource<any>;
  designationchangesDataSource1: MatTableDataSource<any>;
  designationchangesDataSource2: MatTableDataSource<any>;
  designationchangesDataSource3: MatTableDataSource<any>;
  designationchangesdisplayedColumns: string[] = [
    "EmpCode",
    "NamePerRecords",
    "OldDesignation",
    "NewDesignation",
    "DurationFrom",
  ];
  designationchangesdisplayedColumns1: string[] = [
    "EmpCode",
    "NamePerRecords",
    "OldLocationName",
    "LocationName",
    "DurationFrom",
  ];
  designationchangesdisplayedColumns2: string[] = [
    "NamePerRecords",
    "ResignationComments",
    "remove",
  ];
  designationchangesdisplayedColumns3: string[] = [
    "EmpCode",
    "NamePerRecords",
    "FromDate",
    "ToDate",
    "LeaveType",
    "Comments",
  ];

  error: string;
  vendorList = [];
  employeeDetails = [];
  employeeList = [];
  currentMonth = "";
  currentFY = "";
  otherUpdateForm: any;
  @ViewChild("designationchangespaginatorAll", { static: true })
  designationchangespaginatorAll: MatPaginator;
  @ViewChild("designationchangessortAll", { static: true })
  designationchangessortAll: MatSort;
  @ViewChild("designationchangessortAll1", { static: true })
  designationchangessortAll1: MatSort;
  @ViewChild("designationchangessortAll2", { static: true })
  designationchangessortAll2: MatSort;
  @ViewChild("designationchangessortAll3", { static: true })
  designationchangessortAll3: MatSort;
  constructor(
    private _service: MonthClosureService,
    private config: AppConfig,
    public router: Router,
    private toastr: ToastrService,
    public _userService: UserService,
    private otherUpdateFormBuilder: FormBuilder,
    private dialog: MatDialog,
  ) {
    
    this.otherUpdateForm = this.otherUpdateFormBuilder.group({
    otherUpdateDetails: this.otherUpdateFormBuilder.array([]   ),
    });
    this.designationchangesDataSource = new MatTableDataSource();
    this.designationchangesDataSource1 = new MatTableDataSource();
    this.designationchangesDataSource2 = new MatTableDataSource();
    this.designationchangesDataSource3 = new MatTableDataSource();
  }
  ngOnInit() {
    // this.getDesignationChanges();
  }
  getDesignationChanges() {
    this.designationchangesDataSource.data = [];
    this.designationchangesDataSource1.data = [];
    this.designationchangesDataSource2.data = [];
    this.designationchangesDataSource3.data = [];
    this._service.getDesignationChanges(this.currentMonth).subscribe(
      (data: any) => {
        let validationArray = this.otherUpdateFormBuilder.array([]   );
        this.designationchangesDataSource.data =
          data.EmployeeDesignationHistories;
        this.designationchangesDataSource1.data =
          data.EmployeeLocationHistories;
          if(data.ResignationComments!=null && data.ResignationComments.length>0){
            for (var i = 0; i < data.ResignationComments.length; i++) {
              var emp = this.employeeDetails.filter(
                (c) => c.EmpCode == data.ResignationComments[i].EmpCode
              )[0];
           
              if(!!emp)
                data.ResignationComments[i].NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;
             // this.isFreeze = data.ResignationComments[0].IsFreezed;   
              validationArray.push(this.createOtherUpdateFormGroup(data.ResignationComments[i]));
              
              this.otherUpdateForm.setControl("otherUpdateDetails", validationArray);
            }
          }
        // if (this.isFreeze == false ) {
        //   if(data.ResignationComments!=null && data.ResignationComments.length>0)
        //   {
       
        //    }
        //   }
        this.designationchangesDataSource2.data = data.ResignationComments;
        
        this.designationchangesDataSource3.data = data.EmployeeParentalLeaves;
        this.designationchangesDataSource.sort = this.designationchangessortAll;
        this.designationchangesDataSource1.sort =
          this.designationchangessortAll1;
        this.designationchangesDataSource2.sort =
          this.designationchangessortAll2;
        this.designationchangesDataSource3.sort =
          this.designationchangessortAll3;
      },
      (error) => (this.error = error)
    );
  }
  duplicateRowValidator = (formArray: any): { [key: string]: any } | null => {
    const rows = (formArray as FormArray).controls;
    let values = rows.map(row => row.get('NamePerRecords')!=null ?row.get('NamePerRecords').value:null);

    if(!!values)
    {
      
    const duplicates = values.filter((value, index) => values.indexOf(value) !== index);

    rows.forEach(row => {
      const valueControl = row.get('NamePerRecords');
  
        if(valueControl && valueControl.value!="")
        valueControl.setErrors(duplicates.includes(valueControl.value) ? { duplicate: true } : null);
      else{
        //valueControl.setErrors({ required: true });
      }
      
    });

    return duplicates.length > 0 ? { duplicate: true } : null;
  }
  return null;
  };
  saveResignationCommentsDetails() {
    if (this.otherUpdateForm.invalid) {
      this.toastr.warning("Please fill in the required fields");
      this.otherUpdateForm.markAllAsTouched();
      return;
    }
    var result = this.designationchangesDataSource2.data.filter(s => s.IsActive==false ||s.IsActive==null || s.IsActive==undefined );
    if (result != null && result.length > 0) {
      result[0].LoginUserName = this._userService.getEmail();
      result[0].IsFreezed = this.isFreeze;
      this._service.saveResignationCommentsDetails(result).subscribe(
        (data: any[]) => {
          this.toastr.success("Saved Successfully");
          this.getDesignationChanges();
        },
        (error) => (this.error = error)
      );
    }
  }
  getVendors() {
    this._service.getVendors().subscribe(
      (data: any[]) => {
        this.vendorList = data;
      },
      (error) => (this.error = error)
    );
  }
  create() {
    var row = {
      NamePerRecords: "",
      Comments: "",
      remove: "",
    };
    return row;
  }
  otherChangesEmployeeSelectd(event, row) {
    row.EmpCode = event.option.id;
    var emp = this.employeeDetails.filter(
      (c) => c.EmpCode == event.option.id
    )[0];
    row.FY = this.currentFY;
    row.Month = this.currentMonth;
    row.NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;
  }
  doFilterOnEmployee(element) {
    if (!isNullOrUndefined(element.NamePerRecords)) {
      this.employeeList = this.filterEmployee(
        this.employeeDetails,
        element.NamePerRecords
      );
      //element.id = 0;
    }
  }
  filterEmployee(values, NamePerRecords) {
    return values.filter((value) =>
      value.NamePerRecords && value.NamePerRecords !== ""
        ? value.NamePerRecords.toLowerCase().includes(NamePerRecords.toLowerCase()) ||
        value.EmpCode.toString().includes(NamePerRecords)
        : false
    );
  }

  removeAt($event:any,index: number, row: any) {
    const message = "Are you sure you want to delete this record?";
    const dialogData = new ConfirmDialogModel("Confirm Delete", message, "Submit", "OK", "Cancel");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
    $event.preventDefault(); 
    const data = this.designationchangesDataSource2.data;
    if (!!row && row.ResignationId > 0) 
      {
        row.IsActive = true;
        var result = this.designationchangesDataSource2.data.filter(s => s.IsActive==true);
        if (result != null && result.length > 0) {
          result[0].LoginUserName = this._userService.getEmail();
          result[0].IsFreezed = this.isFreeze;
          this._service.saveResignationCommentsDetails(result).subscribe(
            (data: any[]) => {
              this.toastr.success("Deleted Successfully");
              const items = this.otherUpdateForm.get("otherUpdateDetails")as FormArray;
              // Remove the control at the specified index
               items.removeAt(index);
              this.designationchangesDataSource2.data = data.filter(s => s.IsActive!=true);
            },
            (error) => (this.error = error)
          );
        }
      }
    else 
    {
    data.splice(index, 1);
    const items = this.otherUpdateForm.get("otherUpdateDetails")as FormArray;
    // Remove the control at the specified index
     items.removeAt(index);
    this.designationchangesDataSource2.data = data.filter(s => s.IsActive!=true);

    }
    // let validationArray = this.otherUpdateFormBuilder.array([]);
    // this.designationchangesDataSource2.data = data.filter(s => s.IsActive!=true);
    // this.designationchangesDataSource2.data.forEach((detail) => {
    //   if (detail.IsActive != true)
    //     validationArray.push(this.createOtherUpdateFormGroup(detail));
    // });
    // this.otherUpdateForm.setControl("otherUpdateDetails", validationArray);
  }
});
  }
  addRow() {
    this.designationchangesDataSource2.data.push(this.create());
    this.designationchangesDataSource2.filter = "";
    let validationArray = this.otherUpdateFormBuilder.array([]   );

    this.designationchangesDataSource2.data.forEach((detail) => {
      validationArray.push(this.createOtherUpdateFormGroup(detail));
    });
    this.otherUpdateForm.setControl("otherUpdateDetails", validationArray);
  }
  private createOtherUpdateFormGroup(item: any): FormGroup {
    return new FormGroup({

      NamePerRecords: new FormControl( { value: item.NamePerRecords, disabled: this.isFreeze
      }, [
        Validators.required,
      ]),
      ResignationComments: new FormControl( { value: item.ResignationComments, disabled: this.isFreeze
      }, [
        Validators.required,
      ]),
    });
  }
}
